<script>
  export let open = false;
  export let label = "";
  export let width = "24%";
  export let title = "";
  export let tooltipText = "";
  export let allowUnderlyingInteraction = false;

  import { Tooltip } from "paxray-components-svelte";

  function togglePanel(event) {
    open = !open;
    event.currentTarget.blur();
  }
</script>

<aside
  class:open
  class:allow-underlying={allowUnderlyingInteraction}
  class="side-panel"
  style={`--side-panel-width: ${width};`}
>
  <div class="side-panel-content" aria-hidden={!open}>
    {#if title}
      <div class="side-panel-header">
        <strong>{title}</strong>
        {#if tooltipText}<Tooltip text={tooltipText} placement="right" />{/if}
      </div>
    {/if}
    <slot />
  </div>
  <button
    type="button"
    class="side-panel-toggle"
    aria-expanded={open}
    aria-label={open ? `Close ${label}` : `Open ${label}`}
    on:click={togglePanel}
  >
    <span class="side-panel-chevron top"
      ><img
        src={open
          ? "/img/assistant/icons/chevron_right_dark.svg"
          : "/img/assistant/icons/chevron_left_dark.svg"}
        alt=""
      /></span
    >
    <span class="side-panel-label">{label}</span>
    <span class="side-panel-chevron bottom"
      ><img
        src={open
          ? "/img/assistant/icons/chevron_right_dark.svg"
          : "/img/assistant/icons/chevron_left_dark.svg"}
        alt=""
      /></span
    >
  </button>
</aside>

<style>
  .side-panel {
    position: sticky;
    top: 1rem;
    display: flex;
    width: 2rem;
    min-width: 0;
    height: 100%;
    min-height: 0;
    flex-direction: row-reverse;
    background: var(--pax-white);
  }
  .side-panel.open {
    position: absolute;
    z-index: 10;
    top: 0;
    right: 0;
    bottom: 0;
    width: var(--side-panel-width);
    height: auto;
    min-width: 15rem;
    box-shadow: -0.5rem 0 1.25rem rgba(28, 28, 32, 0.08);
  }
  .side-panel.allow-underlying {
    pointer-events: none;
  }
  .side-panel.allow-underlying .side-panel-toggle {
    pointer-events: auto;
  }
  .side-panel.allow-underlying.open .side-panel-content {
    pointer-events: auto;
  }
  .side-panel-content {
    display: none;
    min-width: 0;
    flex: 1;
    flex-direction: column;
    gap: 1.25rem;
    padding: 0 1.5rem 1.5rem;
    overflow-y: auto;
  }
  .open .side-panel-content {
    display: flex;
  }
  .side-panel-header {
    display: flex;
    height: 4rem;
    min-height: 4rem;
    align-items: center;
    gap: 0.5rem;
    margin: 0 -1.5rem;
    padding: 0 1.5rem;
    border-bottom: 1px solid var(--border-color);
  }
  .side-panel-header strong {
    color: var(--pax-black, #1c1c20);
    font-family: Inter;
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1;
  }
  .side-panel-toggle {
    position: relative;
    display: flex;
    width: 2rem;
    min-width: 2rem;
    height: 100%;
    align-items: center;
    justify-content: center;
    border: 0;
    border-right: 1px solid var(--border-color);
    border-left: 1px solid var(--border-color);
    background: var(--pax-white);
    color: var(--pax-black);
    cursor: pointer;
  }
  .side-panel-label {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    font-size: 0.8125rem;
    font-weight: 400;
    white-space: nowrap;
  }
  .side-panel-chevron {
    position: absolute;
    display: flex;
    width: 2rem;
    height: 4rem;
    align-items: center;
    justify-content: center;
  }
  .side-panel-chevron.top {
    top: 0;
  }
  .side-panel-chevron.bottom {
    bottom: 0;
  }
  .side-panel-chevron img {
    width: 1rem;
    height: 1rem;
  }
</style>
